/**
 * The 27 administrative districts of Seychelles — copied verbatim from
 * packages/modules/m30-youth-sports/src/service/districts.ts (zod-validated
 * on the backend) so the portal's district <select> options are always ones
 * the API will actually accept. A frontend copies its backend's own static
 * reference data rather than importing it, same reasoning m30 itself uses
 * for not importing m01's copy of this same list.
 */
export const DISTRICTS = [
  'anse-aux-pins',
  'anse-boileau',
  'anse-etoile',
  'anse-royale',
  'au-cap',
  'baie-lazare',
  'baie-sainte-anne',
  'beau-vallon',
  'bel-air',
  'bel-ombre',
  'cascade',
  'english-river',
  'glacis',
  'grand-anse-mahe',
  'grand-anse-praslin',
  'la-digue',
  'la-riviere-anglaise',
  'les-mamelles',
  'mont-buxton',
  'mont-fleuri',
  'plaisance',
  'pointe-larue',
  'port-glaud',
  'roche-caiman',
  'saint-louis',
  'takamaka',
  'victoria',
] as const;

export function districtLabel(d: string): string {
  return d
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
